import React from "react";
import PropTypes from "prop-types";
import { METRIC_CARDS } from "../followUpConstants";
import styles from "./FollowUpMetrics.module.css";

/**
 * Quatro cards de resumo no topo da página, alimentados por
 * `metrics.enrollmentsByStatus` (rota GET /metrics).
 *
 * Em `loading`, renderiza skeletons no mesmo grid para evitar layout shift.
 */
function MetricCard({ icon, label, value }) {
  return (
    <article className={styles.card} aria-label={`${value} — ${label}`}>
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      <div className={styles.cardBody}>
        <p className={styles.value}>{value}</p>
        <p className={styles.label}>{label}</p>
      </div>
    </article>
  );
}

MetricCard.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

function SkeletonCard() {
  return (
    <div className={styles.skeletonCard} aria-hidden="true">
      <div className={styles.skeletonIcon} />
      <div className={styles.skeletonLines}>
        <div className={`${styles.skeletonLine} ${styles.skeletonLineLg}`} />
        <div className={`${styles.skeletonLine} ${styles.skeletonLineSm}`} />
      </div>
    </div>
  );
}

export default function FollowUpMetrics({ byStatus = null, loading = false }) {
  if (loading) {
    return (
      <div className={styles.grid} aria-busy="true" aria-label="Carregando resumo">
        {METRIC_CARDS.map((c) => (
          <SkeletonCard key={c.key} />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {METRIC_CARDS.map((c) => (
        <MetricCard
          key={c.key}
          icon={c.icon}
          label={c.label}
          value={byStatus?.[c.key] ?? 0}
        />
      ))}
    </div>
  );
}

FollowUpMetrics.propTypes = {
  /** Objeto `enrollmentsByStatus` da rota /metrics. */
  byStatus: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  loading: PropTypes.bool,
};
